<app-profile-loyalty-points-summary
  [customerLoyalty]="customerLoyalty"
  [customerLoyaltyStatus]="customerLoyaltyStatus"
/>
<div class="mb-4"></div>
<app-profile-loyalty-points-transactions *ngIf="customerLoyaltyStatus == 'SUCCESS'"/>
